export class ActiveToggle {
  constructor() {
    this.items = document.querySelectorAll('.js-sidebar-company-item');
    this.eventType = this._getEventType();
    this._addEvent();
  }

  _getEventType() {
    const isTouchCapable =
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch) ||
      navigator.maxTouchPoints > 0 ||
      window.navigator.msMaxTouchPoints > 0;

    return isTouchCapable ? 'touchstart' : 'click';
  }

  _addEvent() {
    this.items.forEach((item) => {
      item.addEventListener(this.eventType, (e) => {
        this.items.forEach((el) => {
          el.classList.remove('is-active-item');
        });
        item.classList.add('is-active-item');
      });
    });
  }
}
